import { render, staticRenderFns } from "./PhotoTask.vue?vue&type=template&id=6a7b5bfe"
import script from "./PhotoTask.vue?vue&type=script&lang=ts"
export * from "./PhotoTask.vue?vue&type=script&lang=ts"
import style0 from "./PhotoTask.vue?vue&type=style&index=0&id=6a7b5bfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports